// src/components/strumenti/MaterialePiastrelle.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"9px 10px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:13, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function MaterialePiastrelle() {
  const [superficie, setSuperficie] = useState("");
  const [lato1, setLato1] = useState("");
  const [lato2, setLato2] = useState("");
  const [scarto, setScarto] = useState("10");
  const [pezziPerScatola, setPezziPerScatola] = useState("");

  const S = leggiNumero(superficie)||0;
  const l1 = leggiNumero(lato1)||0;
  const l2 = leggiNumero(lato2)||0;
  const perc = leggiNumero(scarto)||0;
  const areaPiastrella = (l1>0 && l2>0) ? (l1/100)*(l2/100) : 0; // cm -> m²

  const superficieConScarto = S*(1+perc/100);
  const numPiastrelle = areaPiastrella>0 ? Math.ceil(superficieConScarto/areaPiastrella) : null;
  const perScatola = parseInt(pezziPerScatola)||0;
  const numScatole = (numPiastrelle && perScatola>0) ? Math.ceil(numPiastrelle/perScatola) : null;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:10 }}>
        <div>
          <label style={lbl}>Superficie da rivestire (m²)</label>
          <input value={superficie} onChange={e=>setSuperficie(e.target.value)} style={inp} placeholder="Es. 25"/>
        </div>
        <div>
          <label style={lbl}>% scarto/tagli</label>
          <input value={scarto} onChange={e=>setScarto(e.target.value)} style={inp}/>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:16 }}>
        <div>
          <label style={lbl}>Lato piastrella A (cm)</label>
          <input value={lato1} onChange={e=>setLato1(e.target.value)} style={inp} placeholder="Es. 60"/>
        </div>
        <div>
          <label style={lbl}>Lato piastrella B (cm)</label>
          <input value={lato2} onChange={e=>setLato2(e.target.value)} style={inp} placeholder="Es. 60"/>
        </div>
        <div>
          <label style={lbl}>Pezzi per scatola (facolt.)</label>
          <input value={pezziPerScatola} onChange={e=>setPezziPerScatola(e.target.value)} style={inp} placeholder="Es. 4"/>
        </div>
      </div>

      <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around", marginBottom: numScatole?10:0 }}>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>Superficie con scarto</div>
            <div style={{ fontSize:16, fontWeight:700, color:"#374151" }}>{S>0 ? superficieConScarto.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"} m²</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600 }}>N° piastrelle</div>
            <div style={{ fontSize:20, fontWeight:800, color:"#15803d" }}>{numPiastrelle ?? "—"}</div>
          </div>
        </div>
        {numScatole!==null && (
          <div style={{ textAlign:"center", borderTop:"1px solid #bbf7d0", paddingTop:10 }}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:2 }}>Scatole da acquistare</div>
            <div style={{ fontSize:22, fontWeight:800, color:"#15803d" }}>{numScatole}</div>
          </div>
        )}
      </div>

      <button onClick={()=>{setSuperficie("");setLato1("");setLato2("");setScarto("10");setPezziPerScatola("");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
